import RecaptchaV3 from "js-pimcore-formbuilder/src/js/components/recaptchaV3"
import { getScript } from "js-pimcore-formbuilder/src/js/utils/helpers"

const UC_SERVICE_NAME = "reCAPTCHA"

export default class RecaptchaV3Usercentrics extends RecaptchaV3 {
    bindDependency() {
        // Script already loaded (e.g. another form on the page already triggered it)
        if (typeof window.grecaptcha !== "undefined") {
            window.grecaptcha.ready(() => this.injectTokenToForm())
            return
        }

        // Usercentrics not yet initialised — wait for it
        if (typeof window.UC_UI === "undefined") {
            window.addEventListener("UC_UI_INITIALIZED", () => this.checkConsentAndLoad(), { once: true })
            return
        }

        this.checkConsentAndLoad()
    }

    async checkConsentAndLoad() {
        if (await this.hasConsent()) {
            this.loadScript()
            return
        }

        // Listen for future consent changes (user accepts via the CMP banner)
        const onConsentChange = async () => {
            if (await this.hasConsent()) {
                window.removeEventListener("UC_UI_CMP_EVENT", onConsentChange)
                this.loadScript()
            }
        }

        window.addEventListener("UC_UI_CMP_EVENT", onConsentChange)
    }

    async hasConsent() {
        if (typeof window.UC_UI === "undefined") {
            return false
        }
        try {
            const services = await window.UC_UI.getServicesBaseInfo()
            if (!Array.isArray(services)) {
                return false
            }
            const service = services.find(s => s.name === UC_SERVICE_NAME)
            return service?.consent?.status === true
        } catch (e) {
            return false
        }
    }

    loadScript() {
        getScript(`https://www.google.com/recaptcha/api.js?render=${this.siteKey}`)
            .then(() => {
                window.grecaptcha.ready(() => this.injectTokenToForm())
            })
            .catch((e) => {
                console.error("formbuilder error: unable to load recaptcha script", e)
            })
    }
}
